'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgShare = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 24 24",
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M21.33 9.66c0-.18-.07-.35-.2-.47L15.8 3.86a.677.677 0 0 0-.95.03c-.11.12-.18.28-.18.44v2.66h-2.34c-4.95 0-7.98 1.4-9.11 4.2-.4 1.11-.58 2.29-.55 3.47.13 1.64.59 3.23 1.33 4.69l.1.25.14.31c.04.08.08.16.14.23.06.1.17.17.29.18.09 0 .18-.03.24-.1.06-.06.09-.14.09-.23.01-.09.01-.19 0-.28v-.24c-.07-.49-.1-.93-.1-1.32a8.5 8.5 0 0 1 .18-1.88c.1-.5.27-.98.5-1.44.21-.4.49-.75.83-1.05.33-.29.7-.53 1.1-.72.44-.2.9-.35 1.38-.44.53-.11 1.06-.18 1.6-.22.54-.04 1.15-.06 1.83-.06h2.33v2.65c0 .36.29.66.65.67.18 0 .35-.07.48-.2l5.33-5.33c.13-.12.2-.29.2-.47h.02z",
  vectorEffect: "non-scaling-stroke",
  fill: "currentColor"
})));

exports["default"] = SvgShare;
